"use client"
import { ContentIcon } from "@/components/ContentIcon"
import { ContentTypeTag } from "@/components/ContentTypeTag"
import { RegionsIcon } from "@/components/icons/RegionsIcon"
import type { RecentPage } from "@/lib/hooks/useRecentPages"
import { randomStatColor } from "@/lib/random-stat-color"
import { createAssetUrl } from "@/lib/s3"
import { SUBTREND_BG_COLOR } from "@/lib/static/subtrend"
import { cn } from "@/lib/tailwind"
import Image from "next/image"
import Link from "next/link"
import * as React from "react"

interface RecentProps {
  page: RecentPage
}

export function GlobalSearchRecentPageItem({ page }: RecentProps) {
  const color = React.useMemo(randomStatColor, [])
  return (
    <Link
      prefetch={false}
      href={page.type === "REPORT" ? `/reports/${page.id}` : page.slug}
      className="block px-4 hover:opacity-70"
    >
      <div className="flex w-full items-center">
        <div
          className={cn(
            "!w-[120px] flex h-[70px] flex-shrink-0 items-center justify-center overflow-hidden rounded-lg bg-transparent",
            page.type === "STAT" ? color : "bg-transparent",
          )}
        >
          {(page.type === "INNOVATION" || page.type === "REPORT") && (
            <Image
              alt="cover"
              width={200}
              height={100}
              className="h-full w-full bg-gray-50 object-cover dark:bg-gray-800"
              objectFit="cover"
              src={createAssetUrl(page.cover) || ""}
            />
          )}
          {page.type === "REGION" && <RegionsIcon className="size-40" />}
          {page.type === "MEGATREND" && (
            <ContentIcon bgColor={page.color} icon={createAssetUrl(page.icon)} size={50} className="p-2" />
          )}
          {page.type === "SUBTREND" && (
            <ContentIcon bgColor={SUBTREND_BG_COLOR} icon={createAssetUrl(page.icon)} size={50} className="rounded-full p-2" />
          )}
          {("MACROTREND" === page.type || "INDUSTRY" === page.type) && page.icon && (
            <ContentIcon icon={createAssetUrl(page.icon)} size={50} className="p-0" />
          )}
          {page.type === "STAT" && <p className="font-bold text-black text-xl">{page.title}</p>}
        </div>

        {page.type === "STAT" ? (
          <div className="pl-2">
            <ContentTypeTag className="px-2 py-0.5 text-sm" type={page.type} />
            <p className="line-clamp-2 font-medium text-sm">{page.subTitle}</p>
          </div>
        ) : (
          <div className="w-full pl-2">
            <ContentTypeTag className="px-2 py-0.5 text-sm" type={page.type} />
            <div>
              <p className={cn("line-clamp-2 font-medium", page.type === "REGION" ? "text-base" : "text-sm")}>{page.title}</p>
              {(page.type === "MEGATREND" || page.type === "SUBTREND") && (
                <p className="line-clamp-1 text-xs opacity-70">{page.subTitle}</p>
              )}
            </div>
          </div>
        )}
      </div>
    </Link>
  )
}
